import { Code } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const CodeIcon = createLucideIcon(Code);
